import React, { Component } from 'react';

import { Run, RuleRunner } from '../Validation/RuleRunner'
import { required,selectedNegativeNumber } from '../Validation/Rules';
import Config from "../../config";


const fieldValidations = [
  RuleRunner("selectedTurnover", "Le choix d'un chiffre d'affaires", selectedNegativeNumber)
];

export default class TurnoverChoice extends Component {

  constructor(props) {
    super(props);

    this.state = {
      turnovers: props.turnovers,
      selectedTurnover: props.selectedTurnover,
      communicationMonth : props.communicationMonth,
      validationErrors: {},
    };

    this.handleChange = this.handleChange.bind(this);
  }

  getObject() {
    return this.state;
  }

  handleChange(event) {
    const name = event.target.name;

    // If value is equal to on thus the element is a checkbox
    // so we get the checked value
    var value = event.target.value;
    if (value === "on") {
      value = event.target.checked
    }
  
    // Update the businessHour object
    //responsibles[index][key] = value;
    this.setState({
      [name]: value
    });
  }

  /**
   * @return boolean false if there are some errors
   */
  checkForm() {
    var errors = Run(this.state, fieldValidations);

    if (this.state.communicationMonth <1){
      errors['communicationMonth'] = "Le choix du mois de démarrage est obligatoire !";
    }

    this.setState({
      validationErrors: errors
    });

    return Object.keys(errors).length === 0;
  }

  errorFor(field) {
    return this.state.validationErrors[field] || "";
  }

  renderTurnoverView(turnover) {
    return (
      <label className="radio-box" key={turnover.id} >
        <input type="radio" name="selectedTurnover" 
          value={turnover.id} className="radio-box-button" 
          defaultChecked={turnover.id == this.state.selectedTurnover} 
          onChange={this.handleChange} 
        />
        <span className={"radio-box-label radio-box-label-program-"+Config.program.style}>{turnover.type + " - " + turnover.name}</span>
      </label>
    );
  }

  render() {
    const turnovers = this.state.turnovers.map(
      (turnover) => this.renderTurnoverView(turnover)
    );
    let arrMonths = ['-- Mois --','Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre']
    let ctx = this;
    let domMonths = arrMonths.map(function(name, i){
      if (ctx.state.communicationMonth == i){
        return <option value={i} selected={"selected"}>{name}</option>
      }
      else{
        return <option value={i}>{name}</option>
      }

    })

    return (
      <fieldset className="form-fieldset margin-bottom-notlast-m" id={this.props.id}>
        <legend className="form-fieldset-legend">Votre tranche de chiffre d'affaires (pour vos tableaux statistiques mensuels)</legend>
        { turnovers }
        <div>
          <span className="form-error">{this.errorFor("selectedTurnover")}</span>
        </div>

        <legend className="form-fieldset-legend margin-top-m">Campagnes de communication</legend>
        <p className="margin-bottom-s">
          Démarrage des campagnes au mois de : &nbsp;
          <select name="communicationMonth" onChange={this.handleChange} >
            {domMonths}
          </select>
          <div>
            <span className="form-error">{this.errorFor("communicationMonth")}</span>
          </div>
        </p>

      </fieldset>
    )
  }

}


// WEBPACK FOOTER //
// ./src/components/Forms/TurnoverChoice.js